export default {
    listagem_etiquetas: 'Tag List',
    etiqueta_nao_encontrada: 'No Tags Found',
    etiqueta: 'Tag',
    status: {
        disponivel: 'Available',
        cancelada: 'Canceled',
        pendente: 'Pending',
        usada: 'Used'
    }
}